import { WrappedFieldProps } from 'redux-form';
import React, { FC } from 'react';
import { Dropdown, Menu } from 'antd';

export type Data = {
  value: any;
  label: string;
};

interface Props extends WrappedFieldProps {
  data: Data[];
  customOnChange?: (newValue?: any) => void;
}

export const FormInputDropdown: FC<Props> = ({ input, customOnChange, data, children }) => {
  const RatingDropdownMenu = (
    <Menu>
      {data.map(({ label, value }, index) => (
        <Menu.Item
          key={index}
          onClick={() => {
            input.onChange(value);

            if (customOnChange) {
              customOnChange(value);
            }
          }}
        >
          {label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={RatingDropdownMenu} trigger={['click']}>
      {children}
    </Dropdown>
  );
};
